<template>
    <b-modal v-model="show" :title="$t('config.monthIndex.titleAdd')" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>{{$t("realEstate.field.mibLetterDate")}} <span class="red">*</span></label>
                        <datepicker class="form-control" format="dd/MM/yyyy" v-model="indexDate"
                                    :clear-button="true"
                                    :class="{invalid : $v.indexDate.$error}"></datepicker>
                        <div class="red" v-if="$v.indexDate.$error">
                            {{$t("realEstate.validation.mibLetterDate")}}
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Қиймати <span class="red">*</span></label>
                        <numeric-input v-model="autoYearMonthDto.value" :precision="2"
                                       :class="{invalid : $v.autoYearMonthDto.value.$error}"></numeric-input>
                        <div class="red" v-if="$v.autoYearMonthDto.value.$error">Қиймати</div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save" v-if="!autoYearMonthDto.id">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import {numericTypes} from '@/shared/constants/mask'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {required} from 'vuelidate/lib/validators'
    import {formatDate, parseDate} from '@/shared/utils';

    export default {
        name: "MonthIndexAddView",
        components: {
            'b-modal': bModal,
            Datepicker
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                indexDate: null,
                autoYearMonthDto: {
                    id: null,
                    yearMonthType: "MONTH",
                    month: null,
                    value: null
                }
            }
        },
        validations: {
            autoYearMonthDto: {
                yearMonthType: {
                    required
                },
                value: {
                    required
                }
            },
            indexDate: {
                required
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;
                if (this.indexDate) {
                    this.autoYearMonthDto.month = formatDate(this.indexDate);
                }
                this.$http.post('year-month-index/save', this.autoYearMonthDto)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('monthIndexChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            }
        },
        created() {
            const vm = this;
            this.$eventBus.$on('showMonthIndexAdd', (data) => {
                if (data) {
                    vm.autoYearMonthDto = data;
                    vm.indexDate = parseDate(data.month);
                } else {
                    vm.autoYearMonthDto = {
                        id: null,
                        yearMonthType: "MONTH",
                        month: null,
                        value: null
                    }
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>